var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pm-icon',{staticClass:"is-small has-text-info tooltip",attrs:{"name":"star","data-tooltip":_vm.userName},nativeOn:{"~mouseover":function($event){return _vm.loadUserName($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }